import { useReducer, useEffect } from 'react'
import {
    DataGridLayout,
    UniversalCookieCrumb,
    Grid,
} from '../../UniversalComponents/'
import { useMinimizer } from '../../../context/MinimizeContext'
import BoatManagement from './BoatConfiguration'
import BoatModelConfig from './BoatModel'
import BoatProvisioning from './BoatProvisioning/BoatProvisioning'

import { useTheme, Tab, Tabs } from '@mui/material'
import UnpairedDeviceBoats from './UnpairedDeviceBoats'

interface TabPanelProps {
    children?: React.ReactNode
    dir?: string
    index: number
    value: number
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props

    return (
        <Grid
            container
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Grid container>
                    <Grid item xs={12} sx={{ padding: 2 }}>
                        {children}
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}

const Boats = () => {
    const reducer = (state, newState) => ({ ...state, ...newState })

    const defaultState = {
        currentTab: 0,
        tabName: '',
    }

    const [state, setState] = useReducer(reducer, defaultState)

    const { currentTab, tabName } = state

    const tabs = ['Boat Configuration', 'Boat Model', 'Provisional Boats']

    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) =>
        setState({ currentTab: newValue, tabName: tabs[newValue] })

    const theme = useTheme()
    const { restoredData } = useMinimizer()

    useEffect(() => {
        if (
            restoredData?.id !== undefined &&
            restoredData?.tab === 'configuration'
        ) {
            setState({ currentTab: 0 })
        }
        if (restoredData?.id !== undefined && restoredData?.tab === 'model') {
            setState({ currentTab: 1 })
        }
    }, [restoredData])

    return (
        <DataGridLayout
            cookieCrumbs={<UniversalCookieCrumb customTitle={tabName} />}
            tabBar={
                <Tabs
                    value={currentTab}
                    onChange={setCurrentTab}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="scrollable"
                    aria-label="Osmosis"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    <Tab label="Boat Configuration" />
                    <Tab label="Boat Model" />
                    <Tab label="Provisional Boats" />
                    <Tab label="Boats Without Devices" />
                </Tabs>
            }
            dataGrid={
                <>
                    <TabPanel
                        value={currentTab}
                        index={0}
                        dir={theme.direction}
                    >
                        <BoatManagement />
                    </TabPanel>
                    <TabPanel
                        value={currentTab}
                        index={1}
                        dir={theme.direction}
                    >
                        <BoatModelConfig restoredData={restoredData} />
                    </TabPanel>
                    <TabPanel
                        value={currentTab}
                        index={2}
                        dir={theme.direction}
                    >
                        <BoatProvisioning />
                    </TabPanel>
                    <TabPanel
                        value={currentTab}
                        index={3}
                        dir={theme.direction}
                    >
                        <UnpairedDeviceBoats />
                    </TabPanel>
                </>
            }
        />
    )
}

export default Boats
